import { apiClient } from './apiClient';
import type { User } from '../contexts/AuthContext';

export async function updateUserProfile(updates: Partial<User>): Promise<User> {
  const data = await apiClient.put('/users/me', updates);
  return data as User;
}
